/* jshint esversion: 6 */
import $ from 'jquery';

let submittedModal = false;

$('#productPreview').find('.iw-primaryButton').on('click', function () {
    submittedModal = true;
    $('#SelfPrintProduct, #MobileProduct').trigger('submit', true);
});

let addJSError = function (error) {
        let fieldIdentifier = (function (error) {
            let identifier = error,
                identifierEnd = error.search('_');
            if (identifierEnd !== -1) {
                identifier = error.substring(0, identifierEnd);
            }
            return identifier;
        })(error);
        $('.jSErrorMessages').removeClass('d-none');
        $('#' + fieldIdentifier).each(function () {
            $(this).addClass('f3-form-error');
        });
        $('.iw-' + fieldIdentifier + 'Error').each(function () {
            $(this).removeClass('d-none');
        });
},
    removeJSErrors = function () {
        $('.jSErrorMessages, .jSErrorMessages div').addClass('d-none');
        $('input, textarea').removeClass('f3-form-error');
    };
    $('form [name="position[textFields][font][value]"]').on('change', function () {
        let fontFamily = [
            'SelfPrintBold, sans-serif',
            'SelfPrintItalic, sans-serif'
        ],
        value = $(this).val(),
        $posXInput = $('form [name="position[textFields][posX][value]"]');

        if (!$(this).is(':checked')) {
            return;
        }
        if ($(this).is('[value="italic"]')) {
            fontFamily = fontFamily[1];
        } else {
            fontFamily = fontFamily[0];
        }

        $('#for, #from, #loadValue, #greetText, .SelfPrintProductHiddenInput').css('font-family', fontFamily);
        $('form [name="letterType"][value="' + value + '"]').prop('checked', true);
        $posXInput.val($posXInput.data(value));
    }).change();
    $('#SelfPrintProduct, #MobileProduct').submit(function (event, accepted) {
        const $previewModal = $('#productPreview');
        if (!accepted) {
            event.preventDefault();
            removeJSErrors();

            const valid = (function () {
                let valid = true,
                $loadValue = $('#loadValue'),
                loadValue = $loadValue.val().replace(/\s/, '').replace(',', '.'),
                parsedLoadValue = parseFloat(loadValue),
                loadValueConfig = $loadValue.data(),
                regEx = /^\d+(\.\d*)?$/,
                selectorForInputSize = [
                    '.for.hiddenInput',
                    '.from.hiddenInput',
                ],
                isNan = (!regEx.test(loadValue) || isNaN(parsedLoadValue));

                if (isNan || parsedLoadValue > loadValueConfig.max || parsedLoadValue < loadValueConfig.min) {
                    let forLoadValueError = isNan ? 'loadValue_nan' : 'loadValue_range';
                    valid = false;
                    addJSError(forLoadValueError);
                } else {
                    $loadValue.val(parseFloat(loadValue).toFixed(2).replace('.', ','));
                }

                $.each(selectorForInputSize, function () {
                    let $input = $(String(this));
                    $input.val($('#' + $input.data('error-selector')).val());
                    $input.show();
                    $('.for-' + $input.data('error-selector')).hide();
                    $input.hide();
                });
                return valid;
            })();

            $('.form-control.updateField.popoverInput').focus(function () {
                const id = $(this).attr('id');
                $('.for-' + id + ' .error').fadeOut();
            });

            if (!valid) {
                return;
            }

            let previewUrlsData = $('#frontInputs').data(),
            modalContent = [],
            previewUrls;

            if (previewUrlsData.previewUrl) {
                previewUrls = [previewUrlsData.previewUrl];
            } else {
                previewUrls = [previewUrlsData.previewFrontUrl, previewUrlsData.previewBackUrl];
            }
            if (!submittedModal) {
                previewUrls.forEach(function (imageUrl) {
                    modalContent.push($('<img alt="" src="" class="w-100 h-auto iw-previewImage" />').attr('src', imageUrl + '&' + $('form').serialize()));
                });
                $('.modal-footer .iw-addToBasket').prop('disabled', true);
                $previewModal.find('.modal-body .iw-previewImageArea').html(modalContent);

                $previewModal.find('.modal-body .spinner-border').show();
                $previewModal.find('.modal-body .iw-previewImageArea').hide();

                $previewModal.find('img').on('load', function () {
                    $previewModal.find('.modal-body .spinner-border').hide();
                    $previewModal.find('.modal-body .iw-previewImageArea').show();
                    $('.modal-footer .iw-addToBasket').prop('disabled', false);
                });

                $previewModal.modal('show');
            }
        }
    });
